var _path, _path2, _path3, _path4, _path5;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHammer = function SvgHammer(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.92136 8.87864C7.45847 8.41566 7.19845 7.78776 7.19852 7.13307C7.19858 6.47838 7.45871 5.85053 7.92169 5.38764C8.38467 4.92475 9.01257 4.66473 9.66726 4.66479C10.322 4.66486 10.9498 4.92499 11.4127 5.38797L14.5547 8.53331C14.7842 8.76241 14.9662 9.03452 15.0905 9.33406C15.2147 9.6336 15.2786 9.9547 15.2786 10.279C15.2786 10.6032 15.2147 10.9243 15.0905 11.2239C14.9662 11.5234 14.7842 11.7955 14.5547 12.0246L13.1547 10.6246C12.672 10.2005 12.0515 9.96666 11.409 9.96666C10.7665 9.96666 10.146 10.2005 9.66336 10.6246L7.92136 8.87864Z",
    stroke: "#082244",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.52432 0.500244L8.26993 2.24586L4.77871 5.73708L3.0331 3.99147L6.52432 0.500244Z",
    stroke: "#082244",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.57196 2.94397L9.31796 4.6893",
    stroke: "#082244",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.47733 5.0387L7.22266 6.78403",
    stroke: "#082244",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.372 8.03198L2.03333 13.3726C1.80348 13.6025 1.67435 13.9143 1.67435 14.2393C1.67435 14.5644 1.80348 14.8761 2.03333 15.106C2.26319 15.3358 2.57494 15.465 2.9 15.465C3.22506 15.465 3.53681 15.3358 3.76667 15.106L8.958 9.91398",
    stroke: "#082244",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHammer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hammer.94ca7f9c.svg";
export { ForwardRef as ReactComponent };